module.exports = __webpack_public_path__ + "static/media/krx-derivatives-tutorial.e2754930.jpg";